export default __webpack_public_path__ + "b4fd3b976522950888777b3d5f00b4aa.svg";